// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2379":"bb760c09550f2b44","3680":"729efc713fa5201f","5081":"1b5ef5691516f7e2"}[chunkId] + ".css";
};